const isAsciiDigit = (code) =>
  code >= "0".charCodeAt(0) && code <= "9".charCodeAt(0);

const isAsciiUppercaseLetter = (code) =>
  code >= "A".charCodeAt(0) && code <= "Z".charCodeAt(0);

const isAsciiLowercaseLetter = (code) =>
  code >= "a".charCodeAt(0) && code <= "z".charCodeAt(0);

function isAsciiAlphaNumeric(character) {
  const code = character.charCodeAt(0);

  return [
    isAsciiDigit(code),
    isAsciiUppercaseLetter(code),
    isAsciiLowercaseLetter(code),
  ].some(Boolean);
}

export function normalizeTaxId(value) {
  return Array.from(value == null ? "" : String(value))
    .filter(isAsciiAlphaNumeric)
    .join("")
    .toUpperCase();
}
